import {backendProtocol, backendHost, backendPort} from '../endpoints.js';

export const FILE_UTILITY = backendProtocol + backendHost + backendPort + '/api/files/';

//SYSTEM SETTING ROUTES
export const UPLOAD_FILE = FILE_UTILITY + 'upload-file';
export const GET_ALL_PROCURING_ENTITIES_PAGINATED = FILE_UTILITY + 'getOrganizationsByNamePaginated';
